/**
 * Helpers for determining UI and theme.
 */
import utils from './utils';

interface Auth {
  user: {
    primaryMember: {
      plan: {
        isDsp: boolean;
        isDwm: boolean;
      };
    };
    associatedMembers: Object[];
  };
}

/**
 * Returns true if app should use DSP UI.
 * DSP UI should be used if plan is DSP, or plan is DWM and there are one or more associated members.
 */
export function shouldUseDspUi(auth: Auth): boolean {
  return (
    utils.safeGet(auth, 'user.primaryMember.plan.isDsp', false) ||
    (utils.safeGet(auth, 'user.primaryMember.plan.isDwm', false) &&
      utils.safeGet(auth, 'user.associatedMembers', []).length > 0)
  );
}

/**
 * Returns true if app should use DWM UI.
 * DWM UI should be used if plan is DWM and there are no associated members.
 */
export function shouldUseDwmUi(auth: Auth): boolean {
  return (
    utils.safeGet(auth, 'user.primaryMember.plan.isDwm', false) &&
    utils.safeGet(auth, 'user.associatedMembers', []).length === 0
  );
}
